<template>
  <div class="introduce">
    <div class="introduce-bg"></div>
    <div class="warper clearfix">
      <a-row>
        <a-col :span="18">
          <!-- 文案 -->
          <div class="introduce-text">
            <h1>Help Center</h1>
            <a-dropdown :trigger="['click', 'change']">
              <a-input
                v-model:value="SearchValue"
                placeholder="Enter a keyword"
                style="width: 400px; margin: 0.5rem 0"
                class="ant-dropdown-link"
                size="large"
                @pressEnter="onSearch"
                @change="onChange"
              >
                <template #suffix>
                  <i class="iconfont icon-search" @click="onSearch"></i>
                </template>
              </a-input>
              <template #overlay>
                <a-menu style="max-height:50vh;overflow-y:auto;">
                  <a-menu-item
                    >Search results:
                    <span style="color:#2b6afd">{{ searchList.length }}</span>
                  </a-menu-item>
                  <a-menu-item
                    v-for="item in searchList"
                    :key="item.id"
                    @click="goUrl(item)"
                    >{{ item.docTitle }}</a-menu-item
                  >
                </a-menu>
              </template>
            </a-dropdown>
            <p>
              <span>Popular keywords:</span>
              <span @click="hotKey(1)" class="pointer hoverColor"
                >Auto Config Network</span
              >
              <span @click="hotKey(2)" class="pointer hoverColor"
                >Release Notes</span
              >
            </p>
          </div>
        </a-col>
        <a-col :span="6">
          <img
            style="height: 225px; width: auto"
            src="../assets/icon/bg-icon.png"
          />
        </a-col>
      </a-row>
      <div class="introduce-bottom">
        <a-row type="flex" justify="space-around">
          <a-col @click="sentzhugePoint('快速上手')">
            <!-- <a href="/nocindex/index-noc.html"> -->
            <router-link :to="{ name: 'quickstartguide' }">
              <a-row type="flex">
                <a-col>
                  <div class="cate-img">
                    <img src="@/assets/icon/cate/quick.png" alt="" />
                  </div>
                </a-col>
                <a-col>
                  <div class="cate-name">Quick Start Guide</div>
                  <div class="cate-info" style="line-height: 1.5;">
                    Easy and quick network configuration
                  </div>
                </a-col>
              </a-row>
            </router-link>
          </a-col>
          <a-col @click="sentzhugePoint('发布说明')">
            <router-link :to="{ name: 'release' }">
              <a-row type="flex">
                <a-col>
                  <div class="cate-img">
                    <img src="@/assets/icon/cate/release.png" alt="" />
                  </div>
                </a-col>
                <a-col>
                  <div class="cate-name">Release Notes</div>
                  <div class="cate-info" style="line-height: 1.5;">
                    Stay updated with the features of Ruijie Cloud
                  </div>
                </a-col>
              </a-row>
            </router-link>
          </a-col>
          <!-- <a-col @click="practiceFun" style="cursor:pointer"> -->
          <a-col style="cursor:pointer">
            <router-link :to="{ name: 'ASN' }">
              <a-row type="flex">
                <a-col>
                  <div class="cate-img">
                    <img src="@/assets/icon/cate/practice.png" alt="" />
                  </div>
                </a-col>
                <a-col>
                  <div class="cate-name">Solutions</div>
                  <div class="cate-info" style="line-height: 1.5;">
                    Learn about the highlights of Ruijie Cloud
                  </div>
                </a-col>
              </a-row>
            </router-link>
          </a-col>

          <a-col @click="sentzhugePoint('有问必答')">
            <a target="_blank" href="https://www.ruijienetworks.com/rita">
              <a-row type="flex">
                <a-col>
                  <div class="cate-img">
                    <img src="@/assets/icon/cate/question.png" alt="" />
                  </div>
                </a-col>
                <a-col>
                  <div class="cate-name">Tech Support</div>
                  <div class="cate-info" style="line-height: 1.5;">
                    Online inquiries and technical support
                  </div>
                </a-col>
              </a-row>
            </a>
          </a-col>
        </a-row>
      </div>
    </div>
  </div>
</template>
<script>
import { queryArticleList, categories3 } from "@/utils/query.js";
export default {
  data() {
    return {
      property: "value",
      SearchValue: "",

      searchList: [],
    };
  },
  methods: {
    goUrl(item) {
      console.log(item);
      let id = String(item.docId).split("&")[0];
      if (item.docTitle.includes("更新说明")) {
        this.$router.push({
          name: "releaseArticle",
          query: { id },
        });
      } else {
        this.$router.push({
          name: "ArticleList",
          query: { id },
        });
      }
    },
    onSearch() {
      if (!this.SearchValue) return;
      this.$router.push({
        name: "ArticleList",
        query: {
          SearchValue: this.SearchValue,
        },
      });
    },
    hotKey(key) {
      let name = "";
      let query = {};
      switch (key) {
        case 1:
          name = "ASN";
          break;
        case 2:
          name = "release";
          break;

        default:
          name = "ArticleList";
          query.SearchValue = key;
          break;
      }
      this.$router.push({
        name,
        query,
      });
    },
    async onChange() {
      if (this.SearchValue == "") {
        this.searchList = [];
        return;
      }
      this.searchList = [];
      let res = await queryArticleList(this.SearchValue);
      let { items } = res.data.result;
      if (res.success) {
        this.searchList = [...items];
      }
    },
    sentzhugePoint(lv01 = "") {
      this.zhugePoint("macc-help-文档中心-模块统计", {
        userid: this.GLOBAL.userid, //用户id
        lv01, //一级目录、模块
      });
      console.log("macc-help-文档中心-模块统计", lv01);
    },
    practiceFun() {
      this.sentzhugePoint("产品体验");
    },
    handleOk() {},
  },
};
</script>
<style scoped>
/* introduce */
.introduce {
  margin-top: 68px;
  position: relative;
}
.introduce-bg {
  background: url("../assets/icon/bg.png") center no-repeat;
  background-size: cover;
  position: absolute;
  width: 100%;
  height: 249px;
  left: 0;
  top: 0;
  z-index: -1;
}
.introduce-text {
  z-index: -1;
  padding-top: 30px;
  color: rgba(0, 0, 0, 0.45);
}
.introduce-text::v-deep .ant-input {
  border: 0;
  box-shadow: 0px 2px 8px rgba(205, 214, 237, 0.5);
}
.introduce-text .iconfont {
  font-size: 1.5rem;
  color: #2b6afd;
}
.introduce-text h1 {
  font-size: 36px;
  line-height: 50px;
  color: rgba(0, 0, 0, 0.9);
  margin-bottom: 10px;
}
.introduce-text span {
  display: inline-block;
  font-size: 0.7rem;
  margin-right: 0.5rem;
}

/* introduce-bottom */
.introduce-bottom {
  transform: translateY(-20%);
  z-index: 999 !important;
  box-sizing: border-box;
  padding: 1.5rem 0;
  background: linear-gradient(180deg, #f0f3ff 0%, #ffffff 100%);
  box-shadow: 6px 10px 25px #eceef3;
  border-radius: 6px;
}

.cate-img {
  margin-right: 1rem;
}
.cate-name {
  font-weight: 600;
  font-size: 18px;
  line-height: 2rem;
  color: rgba(0, 0, 0, 0.9);
}
.cate-info {
  font-size: 14px;
  line-height: 2rem;
  color: rgba(0, 0, 0, 0.65);
  max-width: 200px;
}

.Amodal {
}
.Amodal h1 {
  text-align: center;
  font-weight: 500;
  line-height: 2rem;
  margin-top: 1rem;
  color: rgba(0, 0, 0, 0.9);
}
.Amodal h5 {
  text-align: center;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.65);
}
.Amodal::v-deep .ant-modal-footer {
  border: none;
}
.Amodal::v-deep .ant-modal-content {
  background: linear-gradient(360deg, #eaf1ff 0.15%, #ffffff 100%);
}
.Amodal-box {
  text-align: center;
  margin: 1rem;
  height: 199px;
  background: #ffffff;
  border-radius: 8px;
}
.Amodal-box h2 {
  font-weight: 500;
  font-size: 1.2rem;
  line-height: 3rem;
  color: rgba(0, 0, 0, 0.9);
}

p {
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
}
</style>
